export default __webpack_public_path__ + "static/pragicts-automation-services-identity-management-6ee1b4f998f748d6fd4028680411e633.jpg";